const THUMBS_UP = '1f44d';
const CLAP = '1f44f';
const TADA = '1f389';
const FIRE = '1f525';
const HEART = '2764';
const ASTONISHED = '1f632';
const THINKING = '1f914';
export const defaultEmojis = [THUMBS_UP, CLAP, TADA];
export const objectSidebarDefaultEmojis = [THUMBS_UP, CLAP, FIRE, HEART, ASTONISHED, THINKING];
